import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CarouselBannersHome } from 'components/Carousel/CarouselBannersHome';
import './styles.scss';
import { getQueryParams } from 'utils/funciones';
import {urlBannersHome} from 'constants/urls';
import { ApiKeyFetch } from 'api/fetchers/apiKey';

export const ModalBannersHome = () => {
  const [show, setShow] = useState(false);
  const { ShowNovedades } = getQueryParams();
  const [DataBanners, setDataBanners] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const API = ApiKeyFetch.instance();

  useEffect(() => {
    if (ShowNovedades && ShowNovedades === 'true') {
      getInfoBanners()      
    }
  }, []);

  console.log('Novevades', ShowNovedades);

  const getInfoBanners = async () => {        
    const Data = {              
        "tipo": "welcome-home"        
    };
    const res = await API.post(urlBannersHome, Data);    
    if(res?.transaccion){
      setDataBanners(res?.data?.data)
      handleShow();
    }
    return res;
};  
  return (
    <Modal show={show} onHide={handleClose} className="modalBannersHome">
      <Modal.Header closeButton>
        <Modal.Title className="text-mex">Últimas Novedades</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {DataBanners  && (
          <CarouselBannersHome data={DataBanners}/>
        )}
        
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalBannersHome;
